/**
 * Piletilevi Sales terminal services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AnalyticsTracker { 
    type?: AnalyticsTracker.TypeEnum;
    value?: string;
}
export namespace AnalyticsTracker {
    export type TypeEnum = 'meta_pixel' | 'google_analytics' | 'google_analytics_4' | 'google_adwords' | 'google_adwords_conversion' | 'google_ads' | 'tiktok_pixel';
    export const TypeEnum = {
        MetaPixel: 'meta_pixel' as TypeEnum,
        GoogleAnalytics: 'google_analytics' as TypeEnum,
        GoogleAnalytics4: 'google_analytics_4' as TypeEnum,
        GoogleAdwords: 'google_adwords' as TypeEnum,
        GoogleAdwordsConversion: 'google_adwords_conversion' as TypeEnum,
        GoogleAds: 'google_ads' as TypeEnum,
        TiktokPixel: 'tiktok_pixel' as TypeEnum
    };
}


